export default __webpack_public_path__ + "static/media/icon-qr-appcoopeuch-googleplay.a34e79e2.svg";